import React, { Component } from 'react';
import './Player.css';

import Card from './Card';

class Player extends Component {
  rankAndSuit(card) {
    const md = card.match(/(\d\d?|A|K|Q|J)([cdhs])/);
    if (!md) {
      return ['X', 'X'];
    }
    return [md[1], md[2]];
  }

  makeCard(card, i, winner) {
    return (
      <Card key={i}
            winner={winner && winner.indexOf(card) !== -1}
            rank={this.rankAndSuit(card)[0]}
            suit={this.rankAndSuit(card)[1]}/>
    );
  }

  render() {
    const p = this.props.player;
    let door = null;
    if (this.props.cards && this.props.cards.door) {
      door = this.props.cards.door.map((card, i) => this.makeCard(card, i, this.props.winner));
    }
    let hole = null;
    if (this.props.cards && this.props.cards.hole) {
      hole = this.props.cards.hole.map((card, i) => this.makeCard(card, i, this.props.winner));
    }

    const isBetAnimating = this.props.animations && this.props.animations.bet;
    let betAnimation = isBetAnimating ?
        Object.assign({}, this.props.animations.bet) : {};
    let bet;
    if (this.props.bet) {
      bet = (
        <div className="bet">
          <div className="coin"></div>
          <div className={`coin anim ${isBetAnimating ? 'animating' : ''}`}
               style={Object.assign(
                 betAnimation, {opacity: isBetAnimating ? 1 : 0})}>
          </div>
          <div className="amt">{this.props.bet}</div>
        </div>
      );
    }

    const isCoinAnimating = this.props.animations && this.props.animations.coin;
    let coinAnimation = isCoinAnimating ?
        Object.assign({}, this.props.animations.coin) : {};

    const isAnimating = isCoinAnimating || isBetAnimating;
    return (
      <div className={`player ${isAnimating ? 'animating' : ''}`}>
        <div className="name">{p.name}</div>
        <div className="stack">
          <div className="coin"></div>
          <div className={`coin anim ${isCoinAnimating ? 'animating' : ''}`}
               style={Object.assign(
                 coinAnimation, {opacity: isCoinAnimating ? 1 : 0})}>
          </div>
          <div className="amt">{p.stack}</div>
        </div>
        <div className="hole">{hole}</div>
        <div className="door">{door}</div>
        {bet}
      </div>
    );
  }
}

export default Player;



// WEBPACK FOOTER //
// ./src/Player.js